<template>

    <list-container :name="name">

        <list-nav>
            <list-nav-header title="Stock Items" searchable="true"></list-nav-header>


            <list-nav-scroll>

                <ul class="hidden-desktop mobile-list-view">
                    <li v-for="item in items">
                        <div class="icon">
                            <i class="fa fa-square red" aria-hidden="true" v-if="item.stock < 1" title="Out Of Stock"></i>
                            <span v-else>
                                <i class="fa fa-square green" aria-hidden="true" v-if="item.stock > 0" title="In Stock"></i>
                            </span>
                        </div>
                        <div class="info">
                            <span>{{ item.name }}</span>
                            <span>{{ item.stock }}</span>
                            <span>{{ item.sku }}</span>
                            <span>&nbsp;</span>
                        </div>
                    </li>
                    <li>
                        <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                                <span slot="no-more">
                                  End Of Stocklist
                                </span>
                        </infinite-loading>
                    </li>
                </ul>

                <table class="responsive-table hidden-mobile">
                    <thead>
                    <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Image</th>
                        <th scope="col">Name</th>
                        <th scope="col">Unit Of Measure</th>
                        <th scope="col">SKU</th>
                        <th scope="col">In Stock</th>
                        <th scope="col">Manufacturer</th>
                        <th scope="col">Last Updated</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                        <td scope="row" data-label="Reference">{{ item.id }}</td>
                        <td scope="row" data-label="Image" v-if="item.image"><img :src="item.image"/></td>
                        <td scope="row" data-label="Image" v-else>&nbsp;</td>
                        <td scope="row" data-label="Name">
                            <a class="material-name" :href="item._links.frontend.view">
                                {{ item.name }}
                            </a>
                            <div class="material-description">
                                {{ item.description }}
                            </div>
                        </td>
                        <td scope="row" data-label="Unit Of Measure">{{ item.unit_of_measure }}</td>
                        <td scope="row" data-label="SKU">{{ item.sku }}</td>
                        <td scope="row" data-label="In Stock">{{ item.stock }}</td>
                        <td scope="row" data-label="Manufacturer" v-if="item.manufacturer">{{ item.manufacturer.name
                            }}
                        </td>
                        <td scope="row" data-label="Manufacturer" v-else>No Manufacturer</td>
                        <td scope="row" data-label="Last Updated">{{ item.updated_at }}</td>
                    </tr>
                    </tbody>
                </table>
                <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                    <span slot="no-more">
                      End Of Stock Items
                    </span>
                </infinite-loading>
            </list-nav-scroll>
        </list-nav>

    </list-container>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            InfiniteLoading,
        },
        data() {
            return {
                name: 'stock',
                items: [],
                nextPaginationUrl: '',
                search_query: null,
            }
        },
        filters: {

        },
        watch: {
            nextPaginationUrl: function () {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
            }
        },
        computed: {
            has_query() {
                return this.search_query != '' && !_.isNull(this.search_query);
            }
        },
        methods: {
            getItems() {
                var that = this;
                var url = appUrls.materials.index;
                var params = {
                    "stock-controllable": true
                };

                if (this.has_query) {
                    params.query = this.search_query;
                }

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        that.nextPaginationUrl = response.data['meta']['pagination']['_links']['next'];
                    });
            },
            loadMoreItems: _.debounce(function ($state) {
                var that = this;

                if (_.isNull(that.nextPaginationUrl) || that.nextPaginationUrl === '') {
                    $state.loaded();
                    $state.complete();
                    return;
                }

                axios.get(that.nextPaginationUrl)
                    .then(response => {
                        that.items = that.items.concat(response.data.data);
                        if (_.isNull(response.data.meta.pagination._links.next)) {
                            $state.complete();
                        } else {
                            that.nextPaginationUrl = response.data.meta.pagination['_links']['next'];
                            $state.loaded();
                        }
                    });
            }, 500)
        },
        mounted() {
            var that = this;

            this.getItems();

            window.eventBus.$on('list-view-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';

    .material-name {
        font-weight: 500;
        display: block;
        text-decoration: none;
    }

    .material-description {
        font-weight: 400;
        color: #777;
        display: block;
        font-size: 0.8em;
    }
</style>
